import ErrorFallbackPage from "./ErrorFallbackPage";

export default ErrorFallbackPage;
